/**
 * Class/Format label (same rule as Advanced search): DocClass only, or DocClass - format description
 * when the API exposes a real format description (IFS FormatSizeRef.Description as FormatSizeName).
 * Non-descriptive sentinels (e.g. "-") are treated as absent.
 * @param {string} [docClass]
 * @param {string | null | undefined} formatSizeName
 * @returns {string}
 */
export function getDocumentClassFormatLabel(docClass, formatSizeName) {
  const cls = (docClass ?? "").trim();
  const name = formatSizeName != null ? String(formatSizeName).trim() : "";
  if (name.length === 0 || name === "-") {
    return cls;
  }
  return cls.length > 0 ? `${cls} - ${name}` : name;
}
